import Components from './all.vue';

const all = {
    install:function(Vue) {
        Vue.component('all', Components)
    }
}

export default all;